export default __webpack_public_path__ + "static/media/SAS Alert Tone 20.78c09156.mp3";